import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../_metronic/_partials/controls'
import Table, { buttonsStyle, dateFormatter } from '../../../components/tables/table'
import { getCupones, deleteCupon } from '../../../../api/cupon'
import { Button, Tooltip, Chip } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'

const CUPON_TYPE_LABELS = {
  percentage: '% Descuento',
  fixed_amount: '€ Descuento',
  free_shipping: 'Envío Gratis'
}

const SHIPPING_ZONE_LABELS = {
  spain: 'España',
  europe: 'Europa',
  all: 'Todos'
}

function getData(cupones) {
  let data = []
  for (let i = 0; i < cupones.length; ++i) {
    const cupon = cupones[i]
    const elem = {}
    elem.code = cupon.code
    elem.name = cupon.name
    elem.type = cupon.type
    elem.typeLabel = CUPON_TYPE_LABELS[cupon.type] || cupon.type
    
    // Valor del descuento según tipo
    if (cupon.type === 'percentage') {
      elem.value = `${cupon.discountPercentage}%`
      if (cupon.maxDiscount > 0) {
        elem.value += ` (máx ${cupon.maxDiscount}€)`
      }
    } else if (cupon.type === 'fixed_amount') {
      elem.value = `${cupon.discountAmount}€`
    } else if (cupon.type === 'free_shipping') {
      elem.value = SHIPPING_ZONE_LABELS[cupon.shippingZone] || 'Todos'
    }
    
    elem.startDate = cupon.startDate
    elem.endDate = cupon.endDate
    elem.uses = `${cupon.usedCount}${cupon.maxUses > 0 ? '/' + cupon.maxUses : ''}`
    elem.brand = cupon.brand?.name || 'Todas'
    elem.active = cupon.active
    elem.id = cupon._id
    data = data.concat(elem)
  }
  return data
}

export default function CuponesPage() {
  const [data, setData] = useState([])
  const [refresh, setRefresh] = useState(false)
  const [cuponToDelete, setCuponToDelete] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const history = useHistory()

  function buttonFormatter(cell) {
    return (<>
      <Tooltip title="Editar">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => history.push('/edit-cupon/' + cell)}>
          <EditIcon/>
        </Button>
      </Tooltip>
      <Tooltip title="Eliminar">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => {
            setCuponToDelete(cell)
            setOpenConfirmDialog(true)
          }}>
          <DeleteIcon/>
        </Button>
      </Tooltip>
    </>)
  }

  function statusFormatter(cell) {
    const now = new Date()
    const row = data.find(d => d.active === cell && d.id)
    
    if (!cell) {
      return <Chip label="Inactivo" style={{ backgroundColor: '#ef4444', color: '#fff' }} size="small" />
    }
    return <Chip label="Activo" style={{ backgroundColor: '#22c55e', color: '#fff' }} size="small" />
  }

  function typeFormatter(cell, row) {
    let color = '#6b7280'
    if (row.type === 'percentage') color = '#3b82f6'
    else if (row.type === 'fixed_amount') color = '#8b5cf6'
    else if (row.type === 'free_shipping') color = '#10b981'
    
    return <Chip label={cell} style={{ backgroundColor: color, color: '#fff' }} size="small" />
  }

  const columns = [
    { dataField: 'code', text: 'Código', sort: true },
    { dataField: 'name', text: 'Nombre', sort: true },
    { dataField: 'typeLabel', text: 'Tipo', sort: true, formatter: typeFormatter },
    { dataField: 'value', text: 'Valor', sort: true },
    { dataField: 'brand', text: 'Marca', sort: true },
    { dataField: 'startDate', text: 'Inicio', formatter: dateFormatter, sort: true },
    { dataField: 'endDate', text: 'Fin', formatter: dateFormatter, sort: true },
    { dataField: 'uses', text: 'Usos', sort: true },
    { dataField: 'active', text: 'Estado', formatter: statusFormatter, sort: true },
    { dataField: 'id', text: '', formatter: buttonFormatter }
  ]

  useEffect(() => {
    getCupones().then((res) => {
      if (res.status === 200) {
        setData(getData(res.data))
        setRefresh(false)
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'No se pudieron obtener los cupones.' })
    })
  }, [refresh])

  const handleDelete = () => {
    if (!cuponToDelete) return
    
    deleteCupon(cuponToDelete).then((res) => {
      if (res.status === 200 || res.status === 204) {
        alertSuccess({
          title: '¡Eliminado!',
          customMessage: 'Cupón eliminado correctamente.'
        })
        setRefresh(true)
        setOpenConfirmDialog(false)
        setCuponToDelete(null)
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'No se pudo eliminar el cupón.' })
    })
  }

  return (
    <>
      <Card>
        <CardHeader title='Lista de Cupones'>
          <CardHeaderToolbar>
            <Button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push('/edit-cupon')}
            >
              Añadir Cupón
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table
            data={data}
            columns={columns}
          />
          <ConfirmDialog
            title="¿Estás seguro de que quieres eliminar este cupón?"
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={handleDelete}
          />
        </CardBody>
      </Card>
    </>
  );
}

